'use client'

type TextSectionProps = {
  title: string
  content?: string | null
}

export function TextSection({ title, content }: TextSectionProps) {
  if (!content) return null

  return (
    <div>
      <h2 className="mb-2 text-sm font-medium text-gray-500">{title}</h2>
      <div className="rounded-xl border border-gray-200 bg-white p-4">
        <p className="whitespace-pre-wrap text-gray-700">{content}</p>
      </div>
    </div>
  )
}
